import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/styles';
import { getStatusChipClass } from 'components/explore/prospector/layout/StatusColors';

const useStyles = makeStyles({
    container: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        margin: 8
    },
    chip: {
        color: 'white !important',
        height: '16px !important'
    }
});

export default function StatusChip({ status, overrideStatusText = null }) {
    const classes = useStyles();
    const chipClass = getStatusChipClass(status);
    return status ? (
        <Chip
            className={classes.chip}
            classes={{ root: chipClass }}
            label={overrideStatusText ? overrideStatusText : status}
        />
    ) : (
        <></>
    );
}
